/** StringUtilityクラス */
export class StringUtil {

    public static stringFormat(template: string, ...args: string[]) {
        return template.replace(/{(\d+)}/g, (match, number) =>
            typeof args[number] != 'undefined' ? args[number] : match
        );
    }

    /** 3桁カンマに変換する*/
    public static formatNumber(value: string | null): string {
        if (value === null || value === undefined) return '';
        const [integerPart, decimalPart] = value.toString().split('.');
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
    }

    /** YYYYMM文字列の月度を変更する*/
    public static changeMonth(yyyymm: string, offset: number): string {
        let year = parseInt(yyyymm.substring(0, 4));
        let month = parseInt(yyyymm.substring(4, 6));

        // 月度を加算
        month += offset;

        // 13または０の場合は年変更で調整
        while (month > 12) {
            month -= 12;
            year += 1;
        }
        while (month < 1) {
            month += 12;
            year -= 1;
        }

        // YYYYMM文字列にフォーマット
        const monthStr = month < 10 ? '0' + month : month.toString();

        return `${year}${monthStr}`;
    }

    public static formatDateString(dateStr: string): string {

        if (dateStr) {
            if (dateStr.includes('-')) {
                // すでにyyyy-mm形式の場合、そのまま返却
                return dateStr;
            } else {
                // yyyymm形式の場合、yyyy-mm形式に変換
                const year = dateStr.substring(0, 4);
                const month = dateStr.substring(4, 6);
                return `${year}-${month}`;
            }
        }
        else {
            return '';
        }
    }

}